import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const loadInvite = async (apiToken = null, inviteCode = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!inviteCode) {
        console.log("no inviteCode");
        return null;
    }
    console.log("CALLING SERVER with getinviteinformation")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getinviteinformation',
            'apiToken': apiToken,
        'invitecode': inviteCode,
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from getinviteinformation call");
    }).catch((error) => { console.log(error); });
};

export default loadInvite;